import { useState } from 'react';

import { instance } from 'utils/axiosInstance';

// 호스트 가입 시 입력받은 이메일이 이미 가입된 이메일인지 확인한다
export const useCheckExistEmail = () => {
  const [existEmail, setExistEmail] = useState<string>('');

  const handleCheckExistEmail = async (email: string): Promise<boolean> => {
    try {
      await instance.get('/validation/email', { params: { email } });

      return false;
    } catch (error: any) {
      if (error.response?.status === 400) {
        setExistEmail(email);
      } else {
        window.showToast('잠시 후 다시 시도해 주세요.', 'failed');
      }

      return true;
    }
  };

  return { existEmail, handleCheckExistEmail };
};
